export default "__VITE_ASSET__CVZm_$Vr__"